<template>
    <div class="datagrid-wrapper">
        <div class="row">
            <div class="col-md-12 title-holder">
                <h2>{{ table_title }}</h2>
                <div v-if="can_create_edit_access" data-type="buttons" class="sub-grid-buttons">
                    <button id="start-create-access-group" href="/centre/access/create" data-loading-text="Loading...." class="btn btn-light start-create-access-group">
                        Grant access
                    </button>
                </div>
                <div class="search-form-mask open">
                    <form role="search" method="get" class="form-inline search-form">
                        <div class="form-group">
                            <input v-model.lazy="search" class="sb-search-input form-control"
                                   placeholder="Search for.."/>
                        </div>
                        <div v-if="this.search">
                            <button @click.prevent="reset" type="reset" class="btn-icon btn-light sb-icon-reset">
                                <span class="fa fa-close">
                                    <span class="visually-hidden">Reset</span>
                                </span>
                            </button>
                        </div>
                        <button @click.prevent="getCustomAccess" type="submit" class="btn btn-light sb-icon-search">
                            <span class="fa fa-search">
                                <span class="visually-hidden">Search</span>
                            </span>
                        </button>
                    </form>
                </div>
            </div>
        </div>
        <div class="row description">
            <div class="col-md-12"><p>Custom access that is fully editable.</p></div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <table class="datagrid table">
                    <thead>
                    <tr>
                        <th v-for="header in table_headers">
                            <div v-if="header === 'description'">
                                <button type="button" class="btn btn-link"  @click="sortBy('name')">
                                    {{ header }} &#8597;
                                </button>
                            </div>
                            <div v-else-if="header === 'from'">
                                <button type="button" class="btn btn-link" @click="sortBy('access_groups.start_date')">
                                    {{ header }} &#8597;
                                </button>
                            </div>
                            <div v-else-if="header === 'until'">
                                <button type="button" class="btn btn-link" @click="sortBy('access_groups.end_date')">
                                    {{ header }} &#8597;
                                </button>
                            </div>
                            <div v-else class="table-header">
                                <span class="btn-link">{{ header }}</span>
                            </div>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="!access_groups.data">
                        <td :colspan="table_headers.length"><span class="spinner visible anim-spin"></span></td>
                    </tr>
                    <tr v-else-if="!access_groups.data.length">
                        <td :colspan="table_headers.length">No results found</td>
                    </tr>
                    <tr v-for="access_group in access_groups.data" v-bind:key="access_group.id">
                        <td v-for="column in table_columns">
                            <div v-if="column === 'name'">
                                <a :href="`/centre/access/custom/${access_group.id}`">{{ access_group.name }}</a>
                            </div>
                            <div v-else-if="column === 'start_date' || column === 'end_date'">
                                <span>{{ $formatDate(access_group[column], user_date_format) }}</span>
                            </div>
                            <div v-else-if="column === 'status'" v-html="statusHtml(access_group.status)"></div>
                            <div v-else>
                                {{ access_group[column] }}
                            </div>
                        </td>
                    </tr>
                    </tbody>
                    <tfoot>
                    <tr>
                        <td colspan="3">
                            <pagination :data="access_groups" :limit=3 @pagination-change-page="getCustomAccess">
                                <template #prev-nav>
                                    <span>&lt; Previous</span>
                                </template>
                                <template #next-nav>
                                    <span>Next &gt;</span>
                                </template>
                            </pagination>
                        </td>
                    </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "CustomAccessDataTable",
    props: {
        can_create_edit_access: {
            type: Boolean,
        },
        user_date_format: {
            type: String,
        },
        api_endpoint: {
            type: String,
        },
        table_title: {
            type: String,
        },
        table_headers: {
            type: Array,
        },
        table_columns: {
            type: Array,
        },
    },
    data() {
        return {
            access_groups: {},
            paginate: 10,
            search: '',
            sort_key: '',
            reverse: false,
        }
    },
    watch: {
        paginate: function () {
            this.getCustomAccess();
        },
        search: function search() {
            this.getCustomAccess()
        },
    },
    methods: {
        statusHtml(status) {
            let statusTextCss = status === 'expired' ? 'danger' : status;

            return '<span class="text-' + statusTextCss +'">' + status + '</span>';
        },
        getCustomAccess(page = 1) {
            axios.get(this.api_endpoint, {
                params: {
                    page,
                    paginate: this.paginate,
                    q: this.search,
                    sort_key: this.sort_key,
                    sort_direction: this.reverse ? 'DESC' : 'ASC',
                }
            })
                .then(response => {
                    this.access_groups = response.data;
                });
        },
        reset() {
            this.search = '';
        },
        sortBy(sort_key) {
            this.reverse = (this.sort_key === sort_key) ? ! this.reverse : false;
            this.sort_key = sort_key;
            this.getCustomAccess();
        },
    },
    mounted() {
        this.getCustomAccess();
    }
}
</script>
<style scoped>
.btn-link,.btn-link:hover {
    padding: 0 30px 0 0;
    margin: 0;
    vertical-align: bottom;
    color: #babfbf;
    font-weight: bold;
    font-size: 11px;
    outline: none !important;
    border: 0;
    text-decoration: none;
}
</style>
